class RemoteFileReader {
	constructor(url, file_name) {
		this.url = url;
		this.file_name = file_name;
	} 
	
	read(start, end) {
		const headers = {};

		if( start !== undefined && end !== undefined ) {	
			headers['Range'] = `bytes=${start}-${end}`; 
		}	
	
		return fetch( this.url, {
			method: 'GET',
			headers: headers
		} )
		.then( response => response.arrayBuffer() );	
	}
	
	get name() {
		return this.file_name;
	}
	
	get blob() {
		return this.read();
	}
	
}

const remote_file_reader = (url, name) => new RemoteFileReader(url, name);

export {
	remote_file_reader
}